/**
 * Card 86bcx5214 ("Operator wait and auto-close" PRD FR-14, FR-14a): may the customer still write into this
 * conversation? An open one — yes. A closed one — only when the workspace has "Accept Messages in Resolved
 * Conversations" on and less than 24 h have passed since the close; then the server reopens it. Otherwise the widget
 * shows "Conversation closed" and a "Start a new chat" button instead of the input field.
 */
export const REOPEN_WINDOW_MS = 24 * 60 * 60 * 1000;

/**
 * Pure. `{ locked, msLeft }`: `locked` = writing is not allowed; `msLeft` = how long writing stays allowed in a
 * closed conversation (null when that never changes on its own), so the field can change the moment the 24 h run out.
 * A closed conversation with no known close time is locked: the server would start a new one anyway.
 */
export function closedConversationState(conversation, { acceptsMessagesInResolved, now = Date.now() } = {}) {
	if (!conversation || conversation.status !== "Resolved") return { locked: false, msLeft: null };
	if (acceptsMessagesInResolved !== true) return { locked: true, msLeft: null };
	const closedAt = conversation.resolvedAt ? new Date(conversation.resolvedAt).getTime() : NaN;
	if (!Number.isFinite(closedAt)) return { locked: true, msLeft: null };
	const msLeft = closedAt + REOPEN_WINDOW_MS - now;
	return msLeft > 0 ? { locked: false, msLeft } : { locked: true, msLeft: null };
}
